import { Platform } from 'quasar'

export default {
  path: '',
  children: [
    // Home Page
    {
      path: '',
      name: 'Home',
      // Redirect to app splash page on native app
      ...(Platform.is.nativeMobile ? { redirect: '/app/splash/' } : {}),
      component: () => import('src/pages/shared/ContentfulDynamicPage.vue'),
    },
    {
      path: 'shop',
      name: 'ShopHome',
      component: () => import('pages/shared/MainShoppingPage.vue'),
    },
    {
      path: 'search',
      name: 'SearchHome',
      meta: { bodyClass: 'search-page' },
      component: () => import('pages/shared/SearchPage.vue'),
    },

    {
      path: 'product/:productId',
      name: 'ProductHome',
      meta: { bodyClass: 'product-page' },
      component: () => import('pages/shared/ProductDetailPage.vue'),
    },
    {
      path: 'cart',
      name: 'CartHome',
      meta: { protected: true, bodyClass: 'cart-page' },
      component: () => import('pages/shared/CartPage.vue'),
    },
    {
      path: 'checkout',
      name: 'CheckoutHome',
      meta: { protected: true, bodyClass: 'checkout-page' },
      component: () => import('pages/shared/CheckoutPage.vue'),
    },
    {
      path: 'order/:orderId/:exp?',
      name: 'OrderHome',
      meta: { protected: true },
      component: () => import('pages/shared/OrderDetailPage.vue'),
    },
  ],
}
